export type EvoAirportsToggleResult = {
  nextSelected: boolean;
  primary?: AirportFilter[];
  secondary?: AirportFilter[];
};

export function unionAirportsByIata(primary?: AirportFilter[], secondary?: AirportFilter[]): AirportFilter[] {
  const result: AirportFilter[] = [];
  const indexByIata = new Map<string, number>();
  [...(primary || []), ...(secondary || [])].forEach((airport) => {
    const existingIndex = indexByIata.get(airport.iata);
    if (existingIndex === undefined) {
      indexByIata.set(airport.iata, result.length);
      result.push({ ...airport });
      return;
    }
    const existing = result[existingIndex];
    result[existingIndex] = {
      ...existing,
      selected: existing.selected || airport.selected,
      enabled: existing.enabled || airport.enabled,
    };
  });
  return result;
}

export function isIataSelected(iata: string, primary?: AirportFilter[], secondary?: AirportFilter[]): boolean {
  return [...(primary || []), ...(secondary || [])].some((airport) => airport.iata === iata && airport.selected);
}

export function toggleIataSelection(
  iata: string,
  primary?: AirportFilter[],
  secondary?: AirportFilter[]
): EvoAirportsToggleResult {
  const nextSelected = !isIataSelected(iata, primary, secondary);
  const applyToList = (list?: AirportFilter[]) =>
    list?.map((airport) => (airport.iata === iata ? { ...airport, selected: nextSelected } : airport));
  return {
    nextSelected,
    primary: applyToList(primary),
    secondary: applyToList(secondary),
  };
}

export function shouldShowSameAirportsToggle(
  outboundDepartureAirports?: AirportFilter[],
  inboundDepartureAirports?: AirportFilter[]
): boolean {
  return (outboundDepartureAirports?.length || 0) > 1 || (inboundDepartureAirports?.length || 0) > 1;
}
